<template>
  <div
    class="max-h-[80vh] rounded-xl overflow-hidden shadow-[0_4px_44px_0_rgba(178,178,178,0.16)] flex flex-col items-stretch justify-start flex-1 max-w-300 box_center container_width"
  >
    <div
      class="flex flex-col items-start justify-start gap-1.5 px-5 py-6 md:px-10 md:py-7.5 text-white bg-gradient-to-r from-blueG0 to-blueG2 card_bg"
    >
      <div class="flex items-center justify-start gap-2">
        <div class="text-lg md:text-2xl font-bold leading-none">{{ title }}</div>
        <el-tooltip v-if="desc && desc.length > 0" placement="top" class="block whitespace-pre-line text-xs md:hidden">
          <template #content
            ><div class="max-h-41 overflow-y-auto whitespace-pre-line">
              {{ desc }}
            </div></template
          >
          <svg-icon iconName="info-circle-icon" className="tooltip-icon !text-white" />
        </el-tooltip>
      </div>

      <div v-if="desc && desc.length > 0" class="hidden whitespace-pre-line text-xs md:block">
        {{ desc }}
      </div>
    </div>
    <div class="flex-1 flex flex-col" :class="{ 'overflow-hidden': !overflow, 'overflow-y-auto': overflow }">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'RegisterFormContainer',
  props: {
    title: { type: String, required: true },
    desc: { type: String, default: '' },
    overflow: { type: Boolean, default: false }
  }
};
</script>
<style lang="scss" scoped>
.card_bg {
  width: 100%;
  height: auto;
  background: url(~@/assets/images/register/card_bg_img.png) no-repeat;
  background-position: left center;
  background-size: 100% 100%;
  background-color: $primary-blue;
}
.container_width {
  max-width: 1130px;
  background-color: $white;
}
</style>
